import { Link } from "react-router-dom";
import { homepageData } from "@/mocks/homepage";

export default function HeroSection() {
  return (
    <section className="relative h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20athletes%20in%20action%20silhouette%20against%20warm%20sunset%20sky%2C%20modern%20abstract%20geometric%20shapes%20overlay%2C%20clean%20minimalist%20composition%2C%20sports%20energy%20and%20motivation%20concept%2C%20rich%20warm%20orange%20and%20gold%20tones%2C%20artistic%20style&width=1920&height=1080&seq=yunsports-hero-bg&orientation=landscape"
          alt="云体育 - 随时随地享受专业体育运动体验"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <p className="text-white/80 text-sm md:text-base font-medium tracking-wider mb-4 animate-fadeIn">
          {homepageData.hero.subtitle}
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 max-w-4xl mx-auto">
          {homepageData.hero.title}
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-10">
          涵盖体育赛事直播、运动课程、健身计划、体育资讯等全场景服务。加入云体育，随时随地享受专业体育运动体验，让运动融入你的每一天。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            {homepageData.hero.cta}
          </Link>
          <a
            href="#services"
            className="px-8 py-3.5 rounded-full border border-white/30 text-white text-sm md:text-base font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            {homepageData.hero.secondaryCta}
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {homepageData.hero.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-white/60 text-xs md:text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}